import CountDown from '@fragments/CountDown';
import { useCameraOn } from '@hooks/device/useCameraOn';
import { useSpeakerOn } from '@hooks/device/useSpeakerOn';
import { useAttendee } from '@hooks/utils/useAttendee';
import { type FC } from 'react';
import Header from './Header';
import Video from './Video';
import { Container } from './style';

const IntervieweeRoomPage: FC = () => {
  useAttendee();
  useCameraOn();
  useSpeakerOn();

  return (
    <Container>
      <Header />
      <Video />
      <CountDown title='곧 화상면접이 시작됩니다' />
    </Container>
  );
};

export default IntervieweeRoomPage;
